/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/Content/Form/City/Cities/Content/City",
  onMouseEnter,
  onMouseLeave,
  hovered
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  hovered
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let cityValueValueData = fromData.useDataValue({ viewPath,
context: 'city',
path: 'value',
})
  return (<React.Fragment
>
<button
  data-testid="City.Horizontal"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--h-1-9fwn': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="City.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-2-9fwn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-4-9fwn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-9fwn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-6-9fwn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-7-9fwn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-8-9fwn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-9-9fwn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-3-9fwn': hovered ? dtColorsNeutral300 : dtColorsNeutral100}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="city.value"
 text={cityValueValueData}
/>
</div>
</button>
{children}
</React.Fragment>)
}